import OldProjectDashboardStore from "./JobDashboard/ProjectDashboardStore";
import ProjectDashboardStore from "./ProjectDashboard/ProjectDashboard.Store";
import JobPanelCountsStore from "./JobPanelCounts/JobPanelCountsStore";
import JobScheduleViewStore from "./ProjectDashboard/JobScheduleView.Store";
import JobGanttChartStore from "./JobGanttChart/JobGanttChartStore";

const projectManagementStoreList = [
    { name: "oldProjectDashboardStore", store: OldProjectDashboardStore },
    { name: "projectDashboardStore", store: ProjectDashboardStore },
    { name: "jobPanelCountsStore", store: JobPanelCountsStore },
    { name: "jobScheduleViewStore", store: JobScheduleViewStore },
    { name: "jobGanttChartStore", store: JobGanttChartStore },
];

export default projectManagementStoreList;
